import {createApp} from 'vue';

import {library} from '@fortawesome/fontawesome-svg-core';
import {faAngleDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import axios from 'axios';
import VK from './libs/vk-openapi';
import router from './router';
import App from './App';

import store from './store';

import 'bootstrap/scss/bootstrap.scss';

import './styles/form.scss';
import './styles/product-item.scss';
import './styles/promo.scss';

library.add(faAngleDown);

window.axios = require('axios');
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle');

const clickOutside = {
    beforeMount: (el, binding) => {
        el.clickOutsideEvent = event => {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value();
            }
        };
        document.addEventListener('mousedown', el.clickOutsideEvent);
    },
    unmounted: el => {
        document.removeEventListener('mousedown', el.clickOutsideEvent);
    },
};

const app = createApp(App)
    .use(store)
    .use(router)
    .directive('clickOut', clickOutside)
    .component('font-awesome-icon', FontAwesomeIcon);

app.provide(
    'axios',
    app.config.globalProperties.axios
);

app.config.globalProperties.$filters = {
    currency(value) {
        return value / 100;
    },
    currencyFormatted(value) {
        const cent = value % 100;
        const centLabel = cent ? `${cent.toString().padStart(2, 0)} коп.` : '';
        return `${(value - cent) / 100} руб. ${centLabel}`;
    },
    capitalize(value) {
        if (!value) return '';
        // eslint-disable-next-line no-param-reassign
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
};

app.directive('number-filter', {
    beforeUpdate(el) {
        const inputHandler = e => {
            const ch = String.fromCharCode(e.which);
            const re = new RegExp('[0-9]');
            const {value} = e.target;
            if (!ch.match(re)) {
                e.preventDefault();
            }
        };
        el.addEventListener('keypress', inputHandler);
    },
    unmounted(el) {
        const inputHandler = e => {
            const ch = String.fromCharCode(e.which);
            const re = new RegExp('[0-9]');
            const {value} = e.target;
            if (!ch.match(re)) {
                e.preventDefault();
            }
        };
        el.removeEventListener('keypress', inputHandler);
    },
    inputHandler: null
});

app.config.globalProperties.axios = axios;

app.mount('#app');

